import type { CSSProperties, FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface LogoMarkProps {
    className?: string
    animated?: boolean
}

const BAR_CLASS = '[transform-box:fill-box] origin-bottom'

/* Abstract mark: three rising sound bars and a warm full stop. Matches public/favicon.svg. */
export const LogoMark: FC<LogoMarkProps> = ({ className, animated = false }): ReactNode => {
    const motion = animated ? 'motion-safe:group-hover:animate-eq' : undefined

    return (
        <svg
            viewBox='0 0 32 32'
            aria-hidden='true'
            focusable='false'
            className={cn('size-8 shrink-0', className)}
        >
            <rect
                x='0.5'
                y='0.5'
                width='31'
                height='31'
                rx='7.5'
                className='fill-midnight stroke-white/15'
                strokeWidth='1'
            />

            <rect
                x='6.5'
                y='13'
                width='3.75'
                height='10'
                rx='1.875'
                className={cn('fill-electric', BAR_CLASS, motion)}
            />

            <rect
                x='12.25'
                y='8'
                width='3.75'
                height='15'
                rx='1.875'
                className={cn('fill-electric-soft', BAR_CLASS, motion)}
                style={{ '--delay': '-0.4s' } as CSSProperties}
            />

            <rect
                x='18'
                y='11'
                width='3.75'
                height='12'
                rx='1.875'
                className={cn('fill-electric', BAR_CLASS, motion)}
                style={{ '--delay': '-0.8s' } as CSSProperties}
            />

            <circle cx='25' cy='20.25' r='2.75' className='fill-ember' />
        </svg>
    )
}
